import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	mappingFieldUpdateFlagTitle: {
		id: 'project-create-importer-upload-flow.common.utils.use-flag.mapping-field-update-flag-title',
		defaultMessage: 'Changes to field mapping have been updated',
		description: 'Title of success flag to show field mapping change is updated',
	},
	mappingHierarchyUpdateFlagTitle: {
		id: 'project-create-importer-upload-flow.common.utils.use-flag.mapping-hierarchy-update-flag-title',
		defaultMessage: 'Changes to project hierarchy have been updated',
		description: 'Title of success flag to show field mapping change is updated',
	},
	mappingStatusUpdateFlagTitle: {
		id: 'project-create-importer-upload-flow.common.utils.use-flag.mapping-status-update-flag-title',
		defaultMessage: 'Changes to status mapping have been updated',
		description: 'Title of success flag to show status mapping change is updated',
	},
});
